const loadMoreBtnSelector = '.load-more-button';
const loadMoreContentSelector = '.load-more-content';

const loadMoreBtnWrapper = document.querySelector(loadMoreBtnSelector);
const loadMoreBtn = loadMoreBtnWrapper?.firstElementChild;
const loadMoreContent = document.querySelector(loadMoreContentSelector);

(() => {

    if (!loadMoreBtn || !loadMoreContent) {
        return;
    }

    const total = parseInt(loadMoreContent.getAttribute('data-load-more-total'));
    const perPage = parseInt(loadMoreContent.getAttribute('data-load-more-per-page'));

    // Make next `perPage` items visible
    const showNextBatch = () => {
        const currentlyVisible = parseInt(loadMoreContent.getAttribute('data-load-more-already-loaded') ?? 0);
        const numberOfVisible = currentlyVisible + perPage;

        const visibleElements = loadMoreContent.querySelectorAll(`:scope > *:nth-child(-n+${numberOfVisible})`);

        [...visibleElements].forEach((el) => el.classList.remove('hidden'));

        loadMoreContent.setAttribute('data-load-more-already-loaded', numberOfVisible)

        if (numberOfVisible >= total) {
            // Filtering could remove 'hidden' class from this button -> force hide
            loadMoreBtnWrapper.style.display = 'none';
        }
    };

    showNextBatch();


    /* --- LOAD MORE ITEMS ON BUTTON CLICK --- */
    loadMoreBtn.addEventListener('click', showNextBatch);
})();

export {
    loadMoreBtnSelector,
    loadMoreContentSelector,
    loadMoreBtnWrapper,
    loadMoreBtn,
    loadMoreContent,
};
